/* Homnès — correction du franco affiché dans le diagnostic.
   Le fichier homnes-diagnostic.js écrit en dur "Livraison offerte dès 50 €".
   Aucun marché n'a ce seuil : FR 30 €, CH 35 CHF, UE et RU 35 €, US 80 USD.
   Ce script corrige la ligne au moment où elle s'affiche, sans toucher au diagnostic.
   Pour revenir en arrière : retirer la ligne homnes-franco.js du gabarit du diagnostic. */
(function(){
  var FRANCO={FR:{s:30,d:'€'},CH:{s:35,d:'CHF'},US:{s:80,d:'$'},UE:{s:35,d:'€'}};
  var UE=['AT','BE','BG','HR','CY','CZ','DE','DK','EE','FI','GR','HU','IE','IT','LV','LT',
          'LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','GB'];

  function rule(){
    var c=null;
    try{ c=(window.Shopify&&window.Shopify.country)||null; }catch(e){}
    if(!c) return null;
    c=String(c).toUpperCase();
    if(FRANCO[c]) return FRANCO[c];
    if(UE.indexOf(c)>-1) return FRANCO.UE;
    return null;
  }

  /* lit "48,00 €" ou "48.00" et renvoie 48 */
  function total(){
    var el=document.querySelector('.hms-rx__total span:last-child');
    if(!el) return 0;
    var n=parseFloat(el.textContent.replace(/[^0-9,.\-]/g,'').replace(',','.'));
    return isNaN(n)?0:n;
  }

  function texte(){
    var r=rule();
    if(!r) return '';
    var t=total();
    if(t>0 && t>=r.s) return 'Livraison offerte.';
    return 'Livraison offerte dès '+r.s+' '+r.d+'.';
  }

  function corrige(){
    var el=document.querySelector('.hms-rx__deliv');
    if(!el) return;
    var v=texte();
    if(el.textContent!==v){ el.textContent=v; }
    el.style.visibility='visible';
  }

  function observe(){
    var root=document.getElementById('hms-diag-container')||document.body;
    try{
      new MutationObserver(function(){ corrige(); })
        .observe(root,{childList:true,subtree:true,characterData:true});
    }catch(e){}
    corrige();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',observe);
  else observe();
})();
